<template>
  <page-outline :title="$t('requestToPay.new_req_to_pay')"
    icon="icon-sent" returnUrl="/home/RTP">

    <template slot="pageContent">
      <!-- ====================================== -->
      <!--          INVOICES ATTACHMENTS          -->
      <!-- ====================================== -->
      <form-accordion :title="$t('attachments.doc')"
        v-if="rtpType === 'unit'">
        <b-row>
          <b-col>
            <div v-if="typeFile === '1' && attachments.length > 0">
              <b-row v-for="(attachment, id) in attachments" :key="id">
                <b-col sm="4" class="form-group">
                  <div class="d-flex justify-content-between">
                    <label v-model="attachment.AttachmentName"
                      id="application-file-input">
                      {{ attachment.AttachmentName }}
                    </label>
                    <div class="d-flex">
                      <i class="icon fa fa-download mx-1" @click="view(id)"></i>
                      <i class="icon fa fa-search mx-1" @click="openDoc(id)"></i>
                    </div>
                  </div>
                </b-col>
                <b-col sm="2" class="form-group">
                  <f7-button round class="generalBottomButton"
                    @click="clearInvoice(id)">
                    {{ $t('creation_forms.clear_label') }}
                  </f7-button>
                </b-col>
                <b-col class="form-group">
                  <form-write-group-label-input v-model="attachment.AttachmentReference"
                    v-if="attachment.AttachmentName !== ''"
                    :placeholderValue="$t('common.rfrnc')">
                  </form-write-group-label-input>
                </b-col>
              </b-row>
            </div>
            <b-row class="justify-content-start" v-if="typeFile === '1'">
              <b-col xl="4" class="form-group">
                <f7-button round class="generalBottomButton"
                  @click="openImportAttachmentInvoice(typeFile)" :disabled="!canSendAttachment">
                  {{ fileIsFacturX ? 'Importer une Factur-X' : $t('attachments.import_doc') }}
                </f7-button>
              </b-col>
              <b-col xl="4" class="form-group">
                <f7-button round class="generalBottomButton"
                  @click="showDevisForm">
                  {{ $t('attachments.generate_invoiceX') }}
                </f7-button>
              </b-col>
              <b-col xl="4" class="form-group" v-if="isSmartphoneOS">
                <f7-button round class="generalBottomButton"
                  @click="scanDocument($event)">
                  <span>{{ $t('creation_forms.tke_doct_pctr') }}</span>
                </f7-button>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="6" class="form-group">
                <!-- FILES ALREADY IMPORTED FROM MONEYROAD BEGIN -->
                <select class="form-control" id="sel2" readonly v-model="attachmentId" v-if='typeFile === "2"'
                  @change="cloudFileSel()" :disabled="!canSendAttachment">
                  <option value="" default disabled>
                    {{ this.hasCloudAttachments ? $t('creation_forms.slct_a_fl') : $t('attachments.no_document')
                    }}
                  </option>
                  <option v-for="cloudDoc in cloudDocsPicker" :key="cloudDoc.id" :value="cloudDoc.id">
                    {{ cloudDoc.name }}
                  </option>
                </select>
                <!-- FILES ALREADY IMPORTED FROM MONEYROAD END -->
                <input class="item-input hiddenElementAllSize local-file-input"
                  type="file"
                  :key="refreshImport"
                  :disabled="!canSendAttachment"
                  @change="executeOCR($event,'INVOICE')">
                </input>
                <input class="hiddenElementAllSize" type="text" :disabled="canSendAttachment" />
                <input class="hiddenElementAllSize"
                  type="text" id="recommendation-list-input"
                  :disabled="canSendAttachment">
                </input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </form-accordion>

      <hr v-if="rtpType === 'unit'" />

      <!-- ====================================== -->
      <!--            PAYMENT DETAILS             -->
      <!-- ====================================== -->
      <form-accordion id="payment-details" :title="$t('common.formsSubTitle.rqst_to_pay_dtls')">
        <b-row class="justify-content-start">
          <b-col sm="6" xl="6" class="form-group">
            <form-write-group-label-input v-model="remittanceInformation" isMandatory
              :inputLabel="$t('common.rsn')"
              :placeholderValue="$t('common.rsn')">
            </form-write-group-label-input>
          </b-col>
          <b-col sm="6" xl="4" class="form-group">
            <select-bank-account v-model="creditorBank"
              :labelClass="''">
            </select-bank-account>
          </b-col>
          <b-col sm="6" xl="2" class="form-group">
            <form-write-group-label-input v-model="executionDate" isMandatory
              inputType="date" disablePastDates
              :inputLabel="$t('common.execution_date_label')"
              :placeholderValue="$t('common.slct_date')">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row style="display:none;">
          <b-col sm="4" offset-sm="8" xl="3" offset-xl="9" class="form-group">
            <b-form-checkbox v-model="instantPayment"
              :value="1" :unchecked-value="0"
              :disabled="readonly"
              @change="changeInstPmt">
              {{ $t('creation_forms.isSCTInst') }}
            </b-form-checkbox>
          </b-col>
        </b-row>
        <b-row class="justify-content-start" v-if="attachments.length === 0">
          <b-col cols="6" md="3" class="form-group" align-self="center">
            <b-form-radio v-model="rtpType" name="rtpType-radio" value="unit">
              {{ 'RTP unitaire' }}
            </b-form-radio>
          </b-col>
          <b-col cols="6" md="9" xl="3" class="form-group" align-self="center">
            <b-form-radio v-model="rtpType" name="rtpType-radio" value="group">
              {{ 'RTP groupé' }}
            </b-form-radio>
          </b-col>
          <b-col cols="6" xl="3" class="form-group">
            <form-write-group-label-input v-model="nbDebtors" isMandatory
              v-if="rtpType === 'group'"
              inputType="number" :minValue="2" :maxValue="10"
              :inputLabel="'Nombre de débiteurs'"
              :placeholderValue="'Nombre de débiteurs'">
            </form-write-group-label-input>
          </b-col>
          <b-col cols="6" xl="3" class="form-group">
            <form-write-group-label-input v-model="amountTotal" isMandatory
              v-if="rtpType === 'group'"
              inputType="number" :minValue="0"
              :inputLabel="$t('common.amnt_ttl')"
              :placeholderValue="$t('common.amnt_ttl')"
              :warningIndicator="amountTotalSaved !== '0' && amountTotal !== amountTotalSaved"
              :specificMessage="$t('errors.amnt_ttl_chngd')"
              :typingDone="changeDebtorsAmount">
            </form-write-group-label-input>
          </b-col>
        </b-row>
        <b-row class="form-group justify-content-end" v-if="rtpType === 'group'">
          <b-col cols="8">
            <div style="text-align:right;font-weight: bold; font-size:12px; width: 100%;">
              <font :color="sumColor">
                {{ amountTotalSaved === '' ? '0' + '€' : amountTotalSaved + '€' }}
              </font>
              <span>{{ $t('common.of_label') }}</span>
              <font color="#12bcf1">
                {{ amountTotal === '' ? '0' + '€' : amountTotal + '€' }}
              </font>
            </div>
          </b-col>
        </b-row>
      </form-accordion>

      <hr/>

      <!-- ====================================== -->
      <!--            RECIPIENTS LIST             -->
      <!-- ====================================== -->
      <form-accordion id="recipient-list" :title="$t('creation_forms.dbtrs_info')">
        <!--<div class="form-group row justify-content-start">
          <div class="col-sm-6" v-if="isOcrActive === true" v-bind:class="colorBottomButton">
            <input class="item-input hiddenElementAllSize rib-file-input" @change="executeOCR($event,'RIB')"
              type="file" />
            <f7-button round class="attachmentButton buttonAccordionForm"
              @click="importRIB($event)">
              {{ $t('sent.import_RIB_btn',
              {contacttype:
              this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})
              }}
            </f7-button>
          </div>
        </div> DEMOFIX -->
        <b-row v-for="(debtor, debtorIndex) in enteredDebtors" :key="debtor.debtorId"
          class="group-border">
          <b-col v-if="isSmartphoneOS && !isDebtorAnonymous(debtor)" cols="2" xl="1"
            class="text-center" align-self="center" style="padding: 0px">
            <div>
              <a class="d-flex flex-column"
                @click="scanQRCode(debtor.debtorId)">
                <f7-icon fa="qrcode" class="fa-4x"></f7-icon>
                <span>Scan</span>
              </a>
            </div>
          </b-col>
          <b-col>
            <b-row>
              <template v-if="isDebtorAnonymous(debtor)">
                <b-col cols="5" xl="3" class="text-center justify-content-between" align-self="center">
                  <b-row>
                    <b-col cols="6" align-self="center" style="text-align: left; padding-right: 0px">
                      <p>
                        {{$t('requestToPay.anon_debtor')}}
                        <span v-if="enteredDebtors.length > 1">
                          {{(parseInt(debtor.debtorId) + 1).toString()}}
                        </span>
                      </p>
                    </b-col>
                    <b-col cols="6"  align-self="center" style="text-align: left; padding-left: 5px">
                      <f7-icon fa="check" class="text-success"></f7-icon>
                    </b-col>
                  </b-row>
                </b-col>
              </template>
              <template v-if="!isDebtorAnonymous(debtor)">
                <b-col cols="6" xl="3" class="form-group" style="margin-bottom: 5px">
                  <form-contact-dropdown-label-input v-model="debtor.debtorName" isMandatory
                    :id="'debtor-name-' + debtorIndex.toString()"
                    :inputLabel="$t('common.nme')"
                    :placeholderValue="$t('common.nme')"
                    :mandatoryErrorIndicator="beneficiaireError"
                    @input="debtor.debtorSelected = false"
                    @change-iban="debtor.debtorBank = $event"
                    @change-identifier="debtor.debtorEmail = $event"
                    @change-contact="changeContact($event, debtor)">
                  </form-contact-dropdown-label-input>
                </b-col>
                <b-col cols="6" xl="3" class="form-group">
                  <form-write-group-label-input v-model="debtor.debtorEmail" isMandatory
                    :id="'debtor-email-' + debtorIndex.toString()"
                    :inputLabel="$t('common.idtfr')"
                    :placeholderValue="$t('creation_forms.debtor_email_siren_small')"
                    :disabled="debtor.debtorSelected">
                  </form-write-group-label-input>
                </b-col>
                <b-col cols="6" xl="4" class="form-group">
                  <form-write-group-label-input v-model="debtor.debtorBank"
                    :id="'debtor-bank-' + debtorIndex.toString()"
                    :isMandatory="!ibanModifAccepted"
                    :inputLabel="$t('bank_accounts.bank_account_singular')"
                    :placeholderValue="$t('common.ibn')"
                    :disabled="debtor.debtorSelected">
                  </form-write-group-label-input>
                </b-col>
              </template>
              <b-col class="form-group" style="margin-bottom: 0rem">
                <form-write-group-label-input v-model="debtor.amount"
                  :id="'debtor-amount-' + debtorIndex.toString()"
                  :isMandatory="!amountModifAccepted"
                  :inputType="'number'"
                  :inputLabel="$t('common.amnt')"
                  :placeholderValue="$t('common.amnt')"
                  :typingDone="changeAmountTotal"
                  :disabled="enteredDebtors.length > 1 && parseInt(debtor.debtorId) === enteredDebtors.length - 1">
                </form-write-group-label-input>
              </b-col>
              <b-col cols="2" v-if="isDebtorAnonymous(debtor)" class="form-group" style="margin-bottom: 0rem">
                <span class="col-1 fa fa-times-circle text-danger" style="font-size: 25px; margin-top: 30px; cursor: pointer" @click="cancelDebtor(debtor)"></span>
              </b-col>
            </b-row>
            <b-row>
              <template v-if="debugQRCode && debtor.debtorToken !== ''" >
                <b-col cols="6" style="font-size: 9px; color: #b8b8b8">
                  <b>Token: </b> {{debtor.debtorToken}}
                </b-col>
              </template>
            </b-row>
          </b-col>
        </b-row>
      </form-accordion>
      <hr />

      <!-- ====================================== -->
      <!--              RTP SETTINGS              -->
      <!-- ====================================== -->
      <form-accordion id="rtp-settings" :title="$t('common.formsSubTitle.rqst_to_pay_sttngs')">
        <b-row>
          <!-- =================================== -->
          <!--           OPTIONS CHECKBOX          -->
          <!-- =================================== -->
          <b-col sm="6" class="form-group">
            <b-form-checkbox class="mt-sm-2" v-model="ibanModifAccepted"
              :value="true" :unchecked-value="false"
              style="display:none;">
              {{ $t('requestToPay.bankAccountModif') }}
            </b-form-checkbox>
            <b-form-checkbox class="mt-sm-2" v-model="amountModifAccepted"
              :value="true" :unchecked-value="false">
              {{ $t('creation_forms.dbtr_may_ngtt_amnt') }}
            </b-form-checkbox>
            <b-form-checkbox class="mt-sm-2" v-model="dateModifAccepted"
              :value="true" :unchecked-value="false">
              {{ $t('creation_forms.dbtr_may_chng_date') }}
            </b-form-checkbox>
            <b-form-checkbox class="mt-sm-2" v-model="installmentsAccepted"
              :value="true" :unchecked-value="false">
              {{ $t('creation_forms.allowMultipleInst') }}
            </b-form-checkbox>
          </b-col>
          <b-col id="settings-delay" sm="6" class="form-group" style="display:none">
            <!-- =================================== -->
            <!--    DOES ACCEPT NOW RADIO BUTTONS    -->
            <!-- =================================== -->
            {{ $t('common.acceptance') }}: <br />

            <b-form-group id="settings-delay-accept">
              <b-form-radio v-model="doesAcceptNow" name="acceptance-radio" value="now">
                {{ $t('common.accept_now') }}
                <input :disabled="doesAcceptNow !== 'now'" class="miniFormControl" type="text"
                  id="settings-delay-accept-time"
                  v-model="acceptExpirationTime"
                  @input="acceptExpirationTime = isNaN(parseInt(acceptExpirationTime)) ? 1
                                  : (parseInt(acceptExpirationTime) <= 0 ? 1 : parseInt(acceptExpirationTime))" />
                {{ $t('common.after_sent') }}
              </b-form-radio>
              <b-form-radio v-model="doesAcceptNow" name="acceptance-radio" value="later">
                {{ $t('common.accept_later') }}
              </b-form-radio>
            </b-form-group>

            <!-- =================================== -->
            <!--     DOES PAY NOW RADIO BUTTONS      -->
            <!-- =================================== -->
            {{ $t('requestToPay.payment') }}: <br />
            <b-form-group id="settings-delay-pay">
              <b-form-radio v-model="doesPayNow" @change="isSCTInst = false" name="payment-radio" value="none">
                {{ $t('common.no_mr_payment') }}
              </b-form-radio>
              <b-form-radio v-model="doesPayNow" name="payment-radio" value="now">
                {{ $t('common.aftr_accpt') }}
                <input :disabled="doesPayNow !== 'now'" class="miniFormControl" type="text"
                  id="settings-delay-pay-time"
                  v-model="payExpirationTime" @input="payExpirationTime = isNaN(parseInt(payExpirationTime)) ? 1
                                  : (parseInt(payExpirationTime) <= 0 ? 1 : parseInt(payExpirationTime))">
                {{ $t('common.after_hours') }}
              </b-form-radio>
              <b-form-radio v-model="doesPayNow" @change="isSCTInst = false" name="payment-radio" value="later">
                {{ $t('common.payment_later') }}
              </b-form-radio>
            </b-form-group>
          </b-col>
        </b-row>
      </form-accordion>
    </template>
    <!-- ====================================== -->
    <!--             BOTTOM BUTTONS             -->
    <!-- ====================================== -->
    <template slot="footerButtons">
      <b-row class="form-group justify-content-start">
        <!-- <b-col md="3">
          <button round
            class="button-action firstButtonMarginTop milkyBlockBlack leftfav"
            @click="getNameDraft">
            <i class="icon fa fa-save"></i>
            {{ $t('creation_forms.sv_rqust') }}
          </button>
        </b-col> -->
        <b-col cols="6" md="3" offset="6" offset-md="8" class="p-0">
          <f7-button class="button-action milkyBlockBlack" @click="sendPayments">
            <f7-icon fa="paper-plane"></f7-icon>
            <span class="d-none d-xl-inline">{{ $t('creation_forms.snd_req') }}</span>
            <span class="d-xl-none">{{ $t('creation_forms.snd') }}</span>
          </f7-button>
        </b-col>
      </b-row>
    </template>

  </page-outline>
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'

import FormAccordion from '@/components/common/FormAccordion.vue'
import formContactDropdownLabelInput from '@/components/common/formContactDropdownLabelInput.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import selectBankAccount from '@/pages/requests/components/selectBankAccount.vue'

import datePickerMixin from '@/mixins/datePickerMixin'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import Services from '@/helpers/services'
import {validateEmail, validateIBAN, validateSIREN} from '@/helpers/validator'

export default {
  mixins: [datePickerMixin],
  name: 'PRCreateTemplate',
  props: ['subNavTitle', 'capsule', 'saveMessage'],
  components: {
    'form-accordion': FormAccordion,
    'form-contact-dropdown-label-input': formContactDropdownLabelInput,
    'form-write-group-label-input': formWriteGroupLabelInput,
    'page-outline': PageOutline,
    'select-bank-account': selectBankAccount
  },
  data () {
    return {
      acceptExpirationTime: '10',
      amountModifAccepted: false,
      amountTotal: '',
      amountTotalSaved: '',
      attachmentData: '',
      attachmentId: '',
      attachmentName: '',
      attachmentReference: '',
      attachmentReferenceError: false,
      attachments: [],
      bankAccounts: [],
      beneficiaire: '',
      beneficiaireError: false,
      canSendAttachment: false,
      cloudDocsPicker: '',
      cloudFiles: [],
      contacts: [],
      contactsObject: {},
      contactsPicker: '',
      contactSelectionList: [],
      creditorBank: '',
      creditorBankName: '',
      dateModifAccepted: false,
      debtorBank: '',
      debtorEmail: '',
      debtorName: '',
      debtorData: {},
      debtorZoneCode: '',
      debugQRCode: false, // If false, debug div wont be display
      doesAcceptNow: 'now',
      doesPayNow: 'later',
      draftName: '',
      enteredDebtors: [],
      executionDate: '',
      fileEvent: '',
      fileIsFacturX: false,
      fileTypeSelect: [
        {
          text: this.$i18n.t('common.classic_invce_radio'),
          value: false
        },
        {
          text: this.$i18n.t('common.facturx_radio'),
          value: true
        }
      ],
      fromCloud: false,
      hasCloudAttachments: false,
      ibanModifAccepted: false,
      idDraft: '',
      ImmPmtAccepted: false,
      installmentsAccepted: false,
      instantPayment: 1,
      isOcrActive: true,
      isSCTInst: false,
      LMSGsupplierconfig: this.$engine.services.suppliers.LMSGsupplierconfig,
      loadingFile: false,
      marketplaceId: '',
      marketplaceIdError: false,
      nbDebtors: '1',
      payExpirationTime: '10',
      paymentOption: ['normal', 'CB', 'SCTInst'],
      paymentOptionInformation: 'AXEPTA',
      recipientBankAccount: '',
      recipientEmail: '',
      refreshImport: false,
      remittanceInformation: '',
      rtpType: 'unit',
      selected: [],
      selectedContact: false,
      selectedDebtors: {},
      sendPaymentsClicked: false,
      typeFile: '1'
    }
  },
  computed: {
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    readonly () {
      return this.accountType === '1' && this.isComplete === '1' && (this.isValidated === '1' || this.isValidated === '2')
    },
    sumColor () {
      if (Number(this.amountTotal) === Number(this.amountTotalSaved)) {
        return '#12bcf1'
      } else {
        return 'red'
      }
    }
  },
  watch: {
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader(this.$i18n.t('common.imprtng'))
      } else {
        this.$f7.hidePreloader()
      }
    },
    nbDebtors (newVal, oldVal) {
      oldVal = parseInt(oldVal) ? parseInt(oldVal) : 1
      newVal = parseInt(newVal) ? parseInt(newVal) : 1
      if (newVal < 2 || newVal > 10 || this.enteredDebtors.length === newVal) {
        return
      }
      if (oldVal <= 1 || oldVal > 10) {
        oldVal = this.enteredDebtors.length
      }
      if (newVal > oldVal) {
        for (var i = 0; i < newVal - oldVal; i++) {
          let debtorId = oldVal + i
          this.enteredDebtors.push({
            amount: '',
            debtorBank: '',
            debtorEmail: '',
            debtorId: debtorId.toString(),
            debtorName: '',
            debtorSelected: false,
            debtorToken: ''
          })
        }
      } else if (newVal < oldVal) {
        for (var j = 0; j < oldVal - newVal; j++) {
          this.enteredDebtors.pop()
        }
      }
      this.changeDebtorsAmount()
    },
    rtpType (val) {
      switch (val) {
        case 'unit':
          for (var j = 0; j < this.enteredDebtors.length; j++) {
            this.enteredDebtors.pop()
          }
          this.enteredDebtors[0].amount = this.amountTotal
          this.nbDebtors = '1'
          break
        case 'group':
          this.amountTotal = this.enteredDebtors[0].amount
          this.nbDebtors = '2'
          break
        default:
          break
      }
    }
  },
  mounted () {
    this.$engine.services.payments.contactDebtorList = []
    let defaultBankAccount = this.$engine.bankAccounts.get().find(elem => elem.isDefault === '1')
    if (defaultBankAccount) {
      this.creditorBank = defaultBankAccount.iban
      this.creditorBankName = defaultBankAccount.name
    }
    this.isOcrActive = this.$engine.settings.get(Services.PAYMENTS).ocrActivation === '1'
  },
  created () {
    let that = this
    // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

    this.canSendAttachment = this.$engine.rights.rightIs('rtp_request_add_attachment', true)
    // this.canSendAttachment = true

    if (this.$engine.settings.get(1).ocrActivation === '1') {
      that.isOcrActive = true
    }
    // this.instantPayment = this.$engine.settings.directPayments.get().pacs008 === '1' ? 1 : 0
    this.$bus.$on('refresh-contact-payments', (data) => {
      this.debtorName = data.debtorName
      this.debtorBank = data.debtorBank
      this.debtorEmail = data.debtorEmail
    })
    // this.enteredDebtors = this.$engine.services.payments.debtorList
    this.enteredDebtors = []
    this.enteredDebtors.push({
      amount: '',
      debtorBank: '',
      debtorEmail: '',
      debtorId: '0',
      debtorName: '',
      debtorSelected: false,
      debtorToken: ''
    })
    // TODO : selected
    // this.selected = this.$engine.services.payments.contactDebtorList
    this.selected = []
    this.setContacts()
    // Get default value for Negotiation
    // this.executionDate = this.instantPayment === 1 ? moment().format('YYYY-MM-DD') : moment().add(1, 'day').format('YYYY-MM-DD')
    this.executionDate = moment().format('YYYY-MM-DD')
    this.amountModifAccepted = this.$engine.settings.get(1).defaultNegotiationAllowed === '1'
    if (this.capsule === 'draft-edit') {
      this.$bus.$on('refresh-debtor-contact-list', (data) => {
        that.selected = data[0]
        that.selectedDebtor = {}
        that.selectedDebtor = that.contactsObject[this.selected]

        that.debtorName = that.selectedDebtor.name
        that.debtorEmail = that.selectedDebtor.identifier
        that.debtorBank = that.selectedDebtor.iban
      })
    } else {
      this.$bus.$on('refresh-debtor-contact-list', (data) => {
        let contactList = that.$engine.contacts.get()
        if (contactList) {
          let contact = contactList.find(contact => contact.id === data)
          if (contact) {
            that.debtorName = contact.name
            that.debtorEmail = contact.identifier
            that.debtorBank = contact.iban
            that.selectedDebtors = [{
              'name': contact.name,
              'iban': contact.iban,
              'identifier': contact.identifier
            }]
          }
        }
      })
    }
    // this.bankAccounts = this.$settings.currentAccount.ibans
    // this.cloudFiles = this.$settings.currentAccount.docs
    this.bankAccounts = this.$engine.bankAccounts.get()

    this.loadingFile = false
    this.fromCloud = false
    this.creditorBank = ''
    this.creditorBankName = ''
    this.loadPreChargedFile()
    this.loadPreChargedDraft()

    let params = {
      idAcct: this.$engine.user.get().id
    }
    that.$engine.attachments.getRefresh(params).then(response => {
      this.cloudFiles = response.data.docs
      let filesMap = this.cloudFiles.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = {
          id: obj.id,
          name: obj.name,
          type: obj.type,
          internalReference: obj.internalReference
        }
        return rObj
      })
      let filesMapObj = Object.assign({}, ...filesMap)

      if (Object.keys(filesMapObj).length > 0) {
        this.hasCloudAttachments = true
      }
      /* let values = []
      if (Object.keys(filesMapObj).length > 0) {
        values = Object.keys(filesMapObj)
        this.hasCloudAttachments = true
      } else {
        values = ['Nothing Found']
      } */

      this.cloudDocsPicker = filesMapObj
      /* this.cloudDocsPicker = this.$f7.picker({
        input: '#application-file-input',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: values
          }
        ],
        onClose: function (p) {
          if (Object.keys(filesMapObj).length > 0) {
            if (filesMapObj[p.value].id !== that.attachmentId) {
              that.attachmentId = filesMapObj[p.value].id
              that.cloudFileSel()
            }
          }
        },
        onOpen: function (p) {
          if (Object.keys(filesMapObj).length > 0) {
            that.attachmentName = p.value
          }
        }
      }) */
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    this.$bus.$on('close-popup-generate-invoice', e => {
      this.generateInvoice(e)
    })
    this.$bus.$on('close-popup-scanner-qr-code', e => {
      console.log('got data', e)
      var result = e.split(';')
      var idDebtor = result[0]
      this.enteredDebtors[idDebtor].debtorToken = result[1]
    })
  },
  beforeDestroy () {
    this.attachmentData = ''
    this.attachmentId = ''
    this.attachmentName = ''
    this.attachmentReference = ''
    this.attachments = []
    this.debtorName = ''
    this.debtorBank = ''
    this.creditorBank = ''
    this.debtorEmail = ''
    this.remittanceInformation = ''
    this.executionDate = ''
    this.amount = ''
    this.amountModifAccepted = false
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = ''
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.draftName = ''
    this.$engine.services.payments.debtorList = []
    this.$engine.services.payments.contactDebtorList = []

    let attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    let draftObj = {
      Amount: '',
      AttachmentId: '',
      AttachmentName: '',
      AttachmentReference: '',
      CreditorBankAccount: '',
      CreditorIdentifier: '',
      DebtorBankAccount: '',
      DebtorIdentifier: '',
      DebtorName: '',
      ImmPmtAccepted: '',
      amountModifAccepted: '',
      PymtNtr: '',
      RemittanceInformation: '',
      RequestedExecutionDate: '',
      draftName: '',
      idAccount: '',
      idDraft: '',
      isComplete: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
    this.$engine.settings.set({preChargedDraft: draftObj})
    this.$bus.$off('close-popup-generate-invoice')
    this.$bus.$off('close-popup-scanner-qr-code')
  },
  methods: {
    addDebtor (debtor) {
      if (!debtor.debtorToken) {
        if (debtor.debtorName === '') {
          this.$f7.alert('', this.$t('errors.dbtr_invld_nm'))
          return false
        }
        // if (debtor.debtorEmail === '') {
        //   this.$f7.alert('', this.$t('errors.dbtr_invld_email'))
        //   return false
        // }
        if (!validateEmail(debtor.debtorEmail) && !validateSIREN(debtor.debtorEmail)) {
          this.$f7.alert('', this.$t('errors.chng_the_id_to_vld_frmt'))
          return false
        }
        if (debtor.debtorBank.length > 0) {
          if (validateIBAN(debtor.debtorBank) === null) {
            this.$f7.alert('', this.$t('errors.dbtr_invld_bnk'))
            return false
          }
        } else if (debtor.debtorBank.length === 0 && !this.ibanModifAccepted) {
          this.$f7.alert('', this.$t('errors.dbtr_bnk_act_mssng'))
          return false
        }
        this.$engine.services.payments.debtorList.push({
          debtorName: debtor.debtorName,
          debtorBank: debtor.debtorBank,
          debtorEmail: debtor.debtorEmail
        })
      }
      return true
    },
    cancelDebtor (debtor) {
      debtor.debtorName = ''
      debtor.debtorBank = ''
      debtor.debtorEmail = ''
      debtor.debtorToken = ''
    },
    changeAmountTotal () {
      let newAmountTotal = 0
      for (var idDebtor in this.enteredDebtors) {
        if (this.enteredDebtors.length > 1 &&
          parseInt(idDebtor) === this.enteredDebtors.length - 1
        ) {
          let diff = parseFloat(this.amountTotal) - newAmountTotal
          let lastDebtor = this.enteredDebtors[idDebtor]
          if (diff >= 0) {
            lastDebtor.amount = diff.toString()
          } else {
            lastDebtor.amount = '0'
          }
        }
        newAmountTotal += parseFloat(this.enteredDebtors[idDebtor].amount)
      }

      if (newAmountTotal % 1 !== 0) {
        this.amountTotalSaved = newAmountTotal.toFixed(2).toString()
      } else {
        this.amountTotalSaved = newAmountTotal.toString()
      }
    },
    changeContact (e, debtor) {
      this.debtorData = e
      debtor.debtorSelected = true
    },
    changeDebtorsAmount () {
      this.amountTotalSaved = this.amountTotal
      let debtorAmount = Math.floor(this.amountTotal * 100.0 / this.enteredDebtors.length) / 100
      for (var idDebtor = 0; idDebtor < this.enteredDebtors.length; idDebtor++) {
        let newAmount = ''
        if (idDebtor === this.enteredDebtors.length - 1) {
          newAmount = debtorAmount + (this.amountTotal - debtorAmount * this.enteredDebtors.length)
          newAmount = newAmount.toFixed(2).toString()
        } else {
          newAmount = debtorAmount.toFixed(2).toString()
        }
        if (newAmount === '0.00') {
          this.enteredDebtors[idDebtor].amount = ''
        } else {
          this.enteredDebtors[idDebtor].amount = newAmount
        }
      }
    },
    changeInstPmt (val) {
      this.instantPayment = val
      this.executionDate = val === 1 ? moment().format('YYYY-MM-DD') : moment().add(1, 'day').format('YYYY-MM-DD')
    },
    clearInvoice (id) {
      this.refreshImport = !this.refreshImport
      this.attachments.splice(id, 1)
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachmentId.toString())
        .then(response => {
          // let attachmentData = that.$engine.attachments.get().find(elem => elem.id === that.attachmentId)
          // that.amount = parseFloat(attachmentData.amount) % 1 === 0 ? attachmentData.amount : attachmentData.amount.toFixed(2)
          /* that.debtorName = attachmentData.debtorName
          that.debtorEmail = attachmentData.debtorEmail
          that.debtorBank = attachmentData.debtorBankAccount
          that.remittanceInformation = attachmentData.remittanceInformation
          that.executionDate = attachmentData.modDate */
          that.attachmentName = response.data.document_name
          that.attachmentData = response.data.document_data
          that.loadingFile = false
          that.attachmentReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachmentName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    convertDateFormat (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    executeFacturX (file) {
      let that = this

      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        debtorName: 'DebtorName',
        debtorBank: 'DebtorIban',
        debtorEmail: 'DebtorMail',
        creditorBank: 'CreditorIban',
        executionDate: 'ExecutionDate',
        amount: 'AmountTTC',
        remittanceInformation: 'InvoiceReference',
        attachmentReference: 'InvoiceReference'
      }

      this.$f7.showPreloader(that.$i18n.t('sent.facturx_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return this.$engine.services.facturx(file)
      .then(response => {
        // console.log('--- response', response)
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.facturx_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()

        // Extract data from response
        response = response.data
        // console.log('--- response.data', response)

        // Replace form values with OCR values
        this.debtorZoneCode = this.$engine.bankAccounts.getZoneData('EU')

        for (var key in exchangeData) {
          var ExtractedValue = response[exchangeData[key]]
          if (ExtractedValue) {
            if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
              ExtractedValue = ''
            }
            // Formatting values from OCR to conform to accepted formats
            if (exchangeData[key] === 'Amount') {
              ExtractedValue = ExtractedValue.replace(/,/g, '.')
            } else if (exchangeData[key] === 'DebtorIban' || exchangeData[key] === 'CreditorIban') {
              ExtractedValue = ExtractedValue.replace(/ /g, '')
            }

            that[key] = ExtractedValue
            if (key === 'beneficiaire') {
              let contacts = this.$engine.contacts.get()
              for (var kContact in contacts) {
                if (contacts[kContact].name === ExtractedValue) {
                  that.recipientEmail = contacts[kContact].identifier
                }
              }
            }
          }
        }

        // Replace selected contact with new values (trigger child render function)
        this.$refs.selectContact.selectItem({
          name: this.debtorName,
          iban: this.debtorBank,
          identifier: this.debtorEmail
        })
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.file_not_read') + ' ' + err)
        console.log(that.$i18n.t('errors.file_not_read') + ' ' + err)
      })
    },
    executeOCR (e, fileType) {
      if (e === '' && this.fileEvent === '') {
        return
      } else if (e === '') {
        e = this.fileEvent
      }
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        let id = this.attachments.length
        this.attachments.push({})
        var reader = new FileReader()
        reader.onload = (e) => {
          if (this.$engine.settings.get(Services.PAYMENTS).ocrActivation === '0') {
            this.attachmentData = reader.result
            this.attachments[id].AttachmentData = reader.result
            console.log('OCR features not activated.')
          } else if (this.fileType === '') {
            this.fileEvent = e
          } else {
            this.attachmentData = reader.result
            this.attachments[id].AttachmentData = reader.result
            if (this.fileIsFacturX) that.executeFacturX(reader.result)
            else if (this.attachments.length === 1) that.executeOCRFile(fileType, reader.result)
          }
        }
        this.attachmentName = files[0].name
        this.attachments[id].AttachmentName = files[0].name
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert(
          this.$i18n.t('creation_forms.file_size') +
          Math.round(files[0].size / 1000) +
          this.$i18n.t('creation_forms.max_file_size') +
          '500 Kb',
          this.$i18n.t('creation_forms.max_size_title')
        )
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCRFile (filetype, file) {
      let that = this

      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        'RIB': {
          debtorBank: 'Iban',
          debtorName: 'Name'
        },
        'INVOICE': {
          debtorName: 'Name',
          debtorBank: 'Iban',
          debtorEmail: 'Email',
          creditorBank: 'CreditorIBAN',
          executionDate: 'DeliveryDate',
          amount: 'Amount',
          attachmentReference: 'Reference',
          remittanceInformation: 'Reason',
          address: 'StreetName',
          city: 'TownName',
          postalCode: 'PostalCode',
          amountTVA: 'AmountTVA',
          amountHT: 'AmountHT'
        }
      }

      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      // Call API for OCR
      return that.$engine.ocr.ocrRequest(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        console.log('begin', that.enteredDebtors)
        // Extract DocumentData from response
        response = response.data.ControlsInformations

        that.instantPayment = 0
        // Replace form values with OCR values
        that.debtorZoneCode = that.$engine.bankAccounts.getZoneData('EU')
        let fileTypeData = exchangeData[filetype]
        for (var key in fileTypeData) {
          if (response[fileTypeData[key]]) {
            var ExtractedValue = response[fileTypeData[key]].Value
            if (ExtractedValue) {
              if (ExtractedValue === '$Error' || ExtractedValue === '$NotFound') {
                ExtractedValue = ''
              }

              // Formatting values from OCR to conform to accepted formats
              if (fileTypeData[key] === 'Amount') {
                ExtractedValue = ExtractedValue.replace(/,/g, '.')
              } else if (fileTypeData[key] === 'Iban') {
                ExtractedValue = ExtractedValue.replace(/ /g, '')
              }

              if (key === 'debtorName') {
                let contacts = this.$engine.contacts.get()
                for (var kContact in contacts) {
                  if (contacts[kContact].name.toUpperCase() === ExtractedValue.toUpperCase()) {
                    that.enteredDebtors[0].debtorSelected = true
                    that.enteredDebtors[0].debtorEmail = contacts[kContact].identifier
                    if (!response['Iban'] || response['Iban'].Value === '') {
                      that.enteredDebtors[0].debtorBank = contacts[kContact].iban
                    }
                  }
                }
              } else if (key === 'executionDate') {
                let today = moment().format('YYYY-MM-DD')
                if (moment(ExtractedValue).format('YYYY-MM-DD') === today) {
                  that.instantPayment = 1
                }
              } else if (key === 'attachmentReference') {
                let id = that.attachments.length - 1
                that.attachments[id].AttachmentReference = ExtractedValue
              }

              let keyArray = ['amount', 'debtorName']
              if (keyArray.includes(key)) {
                that.enteredDebtors[0][key] = ExtractedValue
              } else {
                that[key] = ExtractedValue
              }
            }
          }
        }
        // Replace selected contact with new values (trigger child render function)
        // this.$refs.selectContact.selectItem({
        //   name: this.debtorName,
        //   iban: this.debtorBank,
        //   identifier: this.debtorEmail
        // })
        console.log('end', that.enteredDebtors)
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    generateInvoice (invoiceData) {
      let that = this
      this.enteredDebtors[0].debtorName = invoiceData.DebtorName
      if (invoiceData.DebtorSiren) {
        this.enteredDebtors[0].debtorEmail = invoiceData.DebtorSiren
      } else {
        this.enteredDebtors[0].debtorEmail = invoiceData.DebtorMail
      }
      this.enteredDebtors[0].debtorBank = invoiceData.DebtorIban
      this.creditorBank = invoiceData.CreditorIban
      this.enteredDebtors[0].amount = invoiceData.AmountTTC
      this.executionDate = invoiceData.ExecutionDate

      this.debtorData = {
        'name': this.enteredDebtors[0].debtorName,
        'identifier': this.enteredDebtors[0].debtorEmail,
        'address': invoiceData.DebtorAddress,
        'zipCode': invoiceData.DebtorZip,
        'city': invoiceData.DebtorCity,
        'country': invoiceData.DebtorCountry,
        'iban': this.enteredDebtors[0].debtorBank,
        'typeContact': invoiceData.DebtorSiren ? '2' : '1'
      }

      this.$f7.showPreloader('Génération de la facture en cours')
      this.$engine.services.generateFacturx(invoiceData)
      .then(response => {
        that.$f7.hidePreloader()
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.$f7.modal({
            title: 'Facture générée',
            text: '<i class="icon fa fa-check"></i>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
          }, 2000)

          let { DocumentName, DocumentData } = response.data
          let id = this.attachments.length
          this.attachments.push({})
          this.attachments[id].AttachmentData = DocumentData
          this.attachments[id].AttachmentName = DocumentName
        }
      })
      .catch(error => {
        that.$f7.hidePreloader()
        errorMessageAlert(error, that)
      })
    },
    getNameDraft () {
      var namedraft = ''
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-payment-create') {
        this.$f7.modal({
          title: this.$t('creation_forms.enter_drft_nm'),
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text"></div>',
          buttons: [
            {
              text: this.$t('common.cncl'),
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: this.$t('common.sve'),
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.saveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.saveInDraft(namedraft)
      }
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    isBankAccountAvailable (bankAccount) {
      if (this.$engine.rights.rightIs('rtp_request_other_euro', false)) {
        return bankAccount.zoneCode === 'EUR'
      }
      return true
    },
    isDebtorAnonymous (debtor) {
      return debtor.debtorToken !== ''
    },
    loadPreChargedDraft () {
      if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
        for (let i = 0; i < this.bankAccounts.length; i++) {
          if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.CreditorBankAccount) {
            this.creditorBankName = this.bankAccounts[i].name
          }
        }

        if (this.$settings.preChargedDraft.AttacAttachmentIdhmentName) {
          this.attachmentId = this.$settings.preChargedDraft.AttachmentId
        }
        if (this.$settings.preChargedDraft.AttachmentName) {
          this.attachmentName = this.$settings.preChargedDraft.AttachmentName
        }
        if (this.$settings.preChargedDraft.Attachment && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
          this.attachmentData = this.$settings.preChargedDraft.Attachment
        }
        if (this.$settings.preChargedDraft.AttachmentReference) {
          this.attachmentReference = this.$settings.preChargedDraft.AttachmentReference
        }
        if (this.$settings.preChargedDraft.DebtorName) {
          this.debtorName = this.$settings.preChargedDraft.DebtorName
        }
        if (this.$settings.preChargedDraft.DebtorBankAccount) {
          this.debtorBank = this.$settings.preChargedDraft.DebtorBankAccount
        }
        if (this.$settings.preChargedDraft.DebtorIdentifier !== '') {
          this.debtorEmail = this.$settings.preChargedDraft.DebtorIdentifier
        }
        if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
          this.creditorBank = this.$settings.preChargedDraft.CreditorBankAccount
        }
        if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
          this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
        }
        if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') {
          this.executionDate = this.$settings.preChargedDraft.RequestedExecutionDate
        }
        if (this.$settings.preChargedDraft.Amount !== '') {
          this.amount = this.$settings.preChargedDraft.Amount
        }
        if (this.$settings.preChargedDraft.amountModifAccepted === 'true') {
          this.amountModifAccepted = true
        } else if (this.$settings.preChargedDraft.amountModifAccepted === 'false') {
          this.amountModifAccepted = false
        }
        if (this.$settings.preChargedDraft.instantPayment !== undefined && this.$settings.preChargedDraft.instantPayment !== '') {
          this.instantPayment = this.$settings.preChargedDraft.instantPayment
        }
        if (this.$settings.preChargedDraft.draftName !== '') {
          this.draftName = this.$settings.preChargedDraft.draftName
        }
        this.idDraft = this.$settings.preChargedDraft.idDraft
        this.ImmPmtAccepted = this.$settings.preChargedDraft.ImmPmtAccepted
        if (this.$settings.preChargedDraft.instantPayment !== undefined && this.$settings.preChargedDraft.instantPayment !== '') {
          this.instantPayment = this.$settings.preChargedDraft.instantPayment
        }
      }
      this.$settings.preChargedDraft = undefined
    },
    loadPreChargedFile () {
      if (typeof (this.$settings.preChargedFile) !== 'undefined') {
        if (this.$settings.preChargedFile.fromCloudList === true) {
          this.fromCloud = true
          this.attachmentId = this.$settings.preChargedFile.id
          this.attachmentName = this.$settings.preChargedFile.name
          this.attachmentData = this.$settings.preChargedFile.data
          this.attachmentReference = this.$settings.preChargedFile.reference
          this.amount = this.$settings.preChargedFile.amount
          this.executionDate = this.$settings.preChargedFile.executionDate
          this.debtorName = this.$settings.preChargedFile.debtorName
          this.debtorEmail = this.$settings.preChargedFile.debtorEmail
          this.debtorBank = this.$settings.preChargedFile.debtorBankAccount
          this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
          if (this.debtorName !== '' && this.debtorEmail === '') {
            let that = this
            this.contacts.forEach((contact, i) => {
              if (contact.name === this.$settings.preChargedFile.debtorName) {
                that.debtorName = contact.name
                that.debtorBank = contact.iban
                that.debtorEmail = contact.identifier
              }
            })
          }
        }
      }
      this.$settings.preChargedFile = undefined
    },
    openDoc (id) {
      console.log('openDoc')
      if (this.attachments[id].AttachmentId) {
        let that = this
        let win = window
        this.$f7.showPreloader(this.$t('common.getting_file'))
        this.$engine.services.payments.getAttachmentDetail(this.attachments[id].AttachmentId)
          .then(response => {
            let dataB64 = response.data.documentData.split(',')[1]
            let contentType = response.data.documentData.split(';')[0].replace(/^data:/, '')
            let blob = b64toBlob(dataB64, contentType)
            let url = window.URL.createObjectURL(blob)
            that.$f7.hidePreloader()
            that.$f7.modal({
              title: that.$t('common.got_file'),
              buttons: [
                {
                  text: that.$t('common.open'),
                  onClick: function () {
                    win.open(url)
                  }
                }
              ]
            })
          })
          .catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
          })
      } else {
        let attachmentData = this.attachments[id].AttachmentData
        let blob = b64toBlob(attachmentData.split(',')[1], attachmentData.split(';')[0].replace(/^data:/, ''))
        const url = window.URL.createObjectURL(blob)
        window.open(url)
      }
    },
    openImportAttachmentInvoice (fileType) {
      if (fileType === '1') {
        let that = this
        that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
      }
      /* TLV 12/09/2020 : Pour la démo du 23/09, le bouton d'attachments donnera directement accès
      * aux fichiers en local */
      /* let buttons1 = [
        {
          text: this.$t('common.import_device'),
          onClick: function () {
            that.attachmentData = ''
            that.attachmentName = ''
            that.attachmentId = ''
          }
        }
      ]
      if (this.hasCloudAttachments) {
        buttons1.push({
          text: this.$t('creation_forms.imprt_frm_moneyroad'),
          onClick: function (event, event2) {
            that.attachmentData = ''
            that.attachmentName = ''
            that.attachmentId = ''
            that.filesPicker(event2)
          }
        })
      }
      let buttons2 = [
        {
          text: this.$t('common.cncl'),
          color: 'red',
          onClick: function () {
          }
        }
      ]
      this.$f7.actions([buttons1, buttons2]) */
    },
    saveInDraft (namedraft) {
      let that = this
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.amountModifAccepted ? 'true' : 'false'
      let debtorsInfo = []

      for (var property in this.selectedDebtors) {
        debtorsInfo.push({
          DebtorName: this.selectedDebtors[property].name,
          DebtorBankAccount: this.selectedDebtors[property].iban,
          DebtorIdentifier: this.selectedDebtors[property].identifier
        })
      }
      for (var debtor in this.enteredDebtors) {
        debtorsInfo.push({
          DebtorName: this.enteredDebtors[debtor].debtorName,
          DebtorBankAccount: this.enteredDebtors[debtor].debtorBank,
          DebtorIdentifier: this.enteredDebtors[debtor].debtorEmail
        })
      }
      if (debtorsInfo.length === 0) {
        debtorsInfo.push({
          DebtorName: '',
          DebtorBankAccount: '',
          DebtorIdentifier: ''
        })
      }
      this.executionDate = this.convertDateFormat(this.executionDate)
      let draftArray = []

      if (that.capsule === 'draft-edit') {
        let requestLoad = []
        requestLoad.push({
          'idDraft': this.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': that.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'CreditorName': this.$engine.user.get().name,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'amountModifAccepted': that.amountModifAccepted,
          'AttachmentId': that.attachmentId,
          'AttachmentName': that.attachmentName,
          'AttachmentReference': that.attachmentReference,
          'Attachment': that.attachmentData,
          'DraftName': that.draftName,
          'instantPayment': that.instantPayment
        })

        this.$engine.drafts.update(requestLoad[0])
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/draft', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else {
        for (var deb in debtorsInfo) {
          draftArray.push({
            'idAccount': this.$engine.user.get().id,
            'CreditorBankAccount': that.creditorBank,
            'CreditorIdentifier': this.$engine.user.get().identifier,
            'CreditorName': this.$engine.user.get().name,
            'DebtorName': debtorsInfo[deb].DebtorName,
            'DebtorBankAccount': debtorsInfo[deb].DebtorBankAccount,
            'DebtorIdentifier': debtorsInfo[deb].DebtorIdentifier,
            'RemittanceInformation': that.remittanceInformation,
            'ImmPmtAccepted': payModAcc,
            'PymtNtr': payNat,
            'RequestedExecutionDate': that.executionDate,
            'Amount': that.amount,
            'amountModifAccepted': that.amountModifAccepted,
            'AttachmentId': that.attachmentId,
            'AttachmentName': that.attachmentName,
            'AttachmentReference': that.attachmentReference,
            'Attachment': that.attachmentData,
            'DraftName': namedraft
          })
        }
        let requestLoad = {
          'drafts': draftArray
        }
        that.$engine.drafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/draft', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    scanDocument ($event) {
      /* eslint-disable no-undef */
      let that = this
      this.locationTypeFile = 0
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }
      const bla = true
      if (bla) {
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()

              reader.onloadend = function (e) {
                // that.executeOCR(e, 'INVOICE')
                that.executeOCRFile('INVOICE', e.target.result.split(',')[1])
              }
              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      } else {
        console.log('OCR Non Actif')
        navigator.camera.getPicture(function cameraSuccess (imageUri) {
          window.resolveLocalFileSystemURL(imageUri, function (entry) {
            entry.file(function (file) {
              var reader = new FileReader()
              reader.onloadend = function (e) {
                that.fileContentArray.push(e.target.result)
              }

              let ca = that
              that.$f7.modal({
                title: 'Please enter the name of the scan',
                // text: 'Enter a name of draft',
                afterText: '<div class="item-input"><input class="inputnamescan" type="text"></div>',
                buttons: [
                  {
                    text: 'Cancel',
                    color: 'red',
                    onClick: function () {
                    }
                  },
                  {
                    text: 'Done',
                    onClick: function () {
                      var lab = ca.Dom7('.inputnamescan').val()
                      ca.fileNameArray.push(lab)
                    }
                  }
                ]
              })
              that.attachmentReference = ''
              that.attachmentId = ''

              reader.readAsDataURL(file)
            }, function () {
              console.log('Error: Creating File object error.')
            })
          }, function () {
            console.log('Error: Resolving URL error.')
          })
        }, function cameraError (error) {
          console.debug('Unable to obtain picture: ' + error, 'app')
        }, options)
      }
      /* eslint-enable no-undef */
    },
    scanQRCode (debtorId) {
      console.log(debtorId)
      this.$bus.$emit('popup-scanner-qr-code', debtorId)
    },
    sendPayments () {
      let that = this
      let requestAlertText = ''
      let responseAlertText = ''
      let groupIdentifier = ''
      let groupReference = ''
      let urlRedirect = ''
      if (this.enteredDebtors.length > 1) {
        requestAlertText = this.$t('requestToPay.rtp_sending_plur')
        responseAlertText = this.$t('requestToPay.rtp_sent_plur')
        groupIdentifier = 'GRP_' + moment().format('YYYYMMDDhhmmss') + '_' + Math.random().toString(36).substr(2, 6)
        groupReference = this.remittanceInformation
        urlRedirect = '/inbox/2/2/'
      } else {
        requestAlertText = this.$t('requestToPay.rtp_sending')
        responseAlertText = this.$t('requestToPay.rtp_sent')
        urlRedirect = '/inbox/2/1/'
      }

      if (this.creditorBank === '') {
        that.$$('.myAccountBlock').show()
        that.$$('.senderChevron').transform('rotate(90deg)')
        this.$f7.alert('', this.$t('errors.miss_creditor'))
        return
      }
      if (this.remittanceInformation === '') {
        this.$f7.alert('', this.$t('errors.enter_reason'))
        return
      }
      let today = moment().format('YYYY-MM-DD')
      if ((this.executionDate === '' && !this.dateModifAccepted) || moment(this.executionDate).format('YYYY-MM-DD') < today) {
        this.$f7.alert('', this.$t('errors.invld_exec_dt'))
        return
      } else if (moment(this.executionDate).format('YYYY-MM-DD') === today &&
          this.installmentsAccepted && !this.dateModifAccepted) {
        this.$f7.alert('', this.$t('errors.exec_dt_nd_instllmnts'))
        return
      }
      if (moment(this.executionDate).format('YYYY-MM-DD') === today) {
        this.instantPayment = 1
      }
      if (this.doesPayNow === 'now') {
        if (!this.payExpirationTime || this.payExpirationTime === '0') {
          this.$f7.alert('You must set an expiration time for the paiement', 'Payment Expiration Time missing')
          return
        }
      } else {
        this.payExpirationTime = ''
      }
      if (this.doesAcceptNow === 'now') {
        if (!this.acceptExpirationTime || this.acceptExpirationTime === '0') {
          this.$f7.alert('You must set an expiration time for the acceptation', 'Acceptation Expiration Time missing')
          return
        }
      } else {
        this.acceptExpirationTime = ''
      }

      let nbRTPSent = 1
      this.$f7.showPreloader(requestAlertText)
      for (var debtorId in this.enteredDebtors) {
        let debtor = this.enteredDebtors[debtorId]
        let debtorsInfo = []
        if (debtor.debtorToken) {
          debtorsInfo.push({
            DebtorProprietaryAccount: debtor.debtorToken
          })
        } else {
          debtorsInfo.push({
            DebtorName: debtor.debtorName,
            DebtorBankAccount: debtor.debtorBank,
            DebtorIdentifier: debtor.debtorEmail
          })
        }
        this.sendPaymentsClicked = true

        if (!this.addDebtor(debtor)) {
          this.$f7.hidePreloader()
          return
        }
        let amount = parseFloat(debtor.amount)
        if (!amount && !this.amountModifAccepted) {
          this.$f7.hidePreloader()
          this.$f7.alert('', this.$t('errors.miss_amount'))
          return
        } else if (amount < 0 || (amount === 0 && !this.amountModifAccepted)) {
          this.$f7.hidePreloader()
          this.$f7.alert('', this.$t('errors.invld_amnt'))
          return
        }

        let ImmPmtAcc = this.ImmPmtAccepted ? 'true' : 'false'
        let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
        this.executionDate = this.convertDateFormat(this.executionDate)
        let jsonToCreate = {
          CreditorIdentifier: this.$engine.user.get().identifier,
          CreditorBankAccount: that.creditorBank,
          CreditorName: this.$engine.user.get().name,
          Debtors: debtorsInfo,
          RemittanceInformation: that.remittanceInformation,
          ImmPmtAccepted: ImmPmtAcc,
          PymtNtr: payNat,
          RequestedExecutionDate: that.executionDate,
          Amount: debtor.amount % 1 === 0 ? debtor.amount : Number.parseFloat(debtor.amount).toFixed(2),
          Currency: this.bankAccounts.find(acc => acc.iban === this.creditorBank).zoneCode,
          Accept: (this.doesAcceptNow ? 'now' : 'later'),
          AcceptExpirationTime: this.acceptExpirationTime,
          Pay: this.doesPayNow,
          PayExpirationTime: this.payExpirationTime,
          AcceptModifyAmount: (this.amountModifAccepted ? '1' : '0'),
          AcceptModifyExecutionDate: (this.dateModifAccepted ? '1' : '0'),
          AcceptModifyBankAccount: (this.ibanModifAccepted ? '1' : '0'),
          AcceptMultipleInstalments: (this.installmentsAccepted ? '1' : '0'),
          InstantPayment: '1',
          PaymentOption: this.paymentOption,
          PaymentOptionInformation: this.paymentOptionInformation
        }
        if (groupIdentifier !== '') {
          jsonToCreate.GroupId = groupIdentifier
          jsonToCreate.GroupReference = groupReference
          jsonToCreate.Attachments = []
        } else {
          jsonToCreate.Attachments = that.attachments
        }

        that.$engine.services.payments
        .create(jsonToCreate)
        .then(response => {
          that.status = response.status
          if (response.status === 200) {
            // that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
            let paymentsSent = false
            if (that.enteredDebtors.length === 1 ||
              (that.enteredDebtors.length > 1 && nbRTPSent === that.enteredDebtors.length)) {
              paymentsSent = true
            }
            if (paymentsSent) {
              that.$bus.$emit('payments-sent')
              that.$f7.hidePreloader()
              this.$f7.modal({
                title: responseAlertText,
                text: '<i class="icon fa fa-check"></i>'
              })
              this.$engine.services.payments.debtorList = []
              this.$engine.services.payments.contactDebtorList = []
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: urlRedirect})
              }, 2000)
            } else {
              nbRTPSent++
            }
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    setContacts () {
      let that = this
      this.$engine.services.payments.contactDebtorList = []
      this.$engine.services.payments.contactGroupsSelected = []
      this.contacts = this.$engine.contacts.get()
      this.contacts.forEach((contact, i) => {
        that.contactsObject[that.contacts[i].id] = that.contacts[i]
      })
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({
          label: this.$engine.contacts.get(j).label,
          iban: this.$engine.contacts.get(j).iban,
          identifier: this.$engine.contacts.get(j).identifier,
          name: this.$engine.contacts.get(j).name,
          id: this.$engine.contacts.get(j).id
        })
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = contactList
    },
    showDevisForm () {
      this.debtorData = {
        'name': this.enteredDebtors[0].debtorName,
        'identifier': this.enteredDebtors[0].debtorEmail,
        'address': this.address,
        'zipCode': this.postalCode,
        'city': this.city,
        'country': this.country,
        'iban': this.enteredDebtors[0].debtorBank,
        'typeContact': this.enteredDebtors[0].DebtorSiren ? '2' : '1'
      }
      let products = []
      if (this.remittanceInformation || this.amountHT) {
        products.push({
          Desc: this.remittanceInformation,
          Qte: '1',
          Amount: this.amountHT
        })
      }
      this.$bus.$emit('popup-devis-form', {
        invoiceType: 'FacturX',
        invoiceRef: this.attachmentReference,
        dateExec: moment(this.executionDate).format('DD/MM/yyyy'),
        sellerIBAN: this.creditorBank,
        amountHT: this.enteredDebtors[0].AmountHT,
        amountTaxes: this.amountTVA,
        buyer: {
          ...this.debtorData,
          ...{
            name: this.enteredDebtors[0].debtorName,
            identifier: this.enteredDebtors[0].debtorEmail,
            iban: this.enteredDebtors[0].debtorBank
          }
        },
        products: products
      })
    },
    view (id) {
      console.log('view')
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let that = this
      if (this.attachments[id].AttachmentId) {
        this.$f7.showPreloader(this.$t('common.opnng_fl'))
        this.$engine.services.payments.getAttachmentDetail(this.attachments[id].AttachmentId)
          .then(response => {
            this.$engine.settings.set({Attachment: {
              data: response.data.documentData,
              name: response.data.documentName,
              mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
              id: id
            }})
            if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
              that.writeToFile(
                response.data.documentName,
                response.data.documentData,
                response.data.documentData.split(';')[0].replace(/^data:/, ''),
                true,
                function (filePath, fileType, fileName) {
                  that.readFile(filePath, fileType, fileName)
                },
                function () {
                  that.$f7.alert('', that.$t('errors.err_crtng_fl'))
                }
              )
            } else {
              let dataB64 = response.data.documentData.split(',')[1]
              let contentType = response.data.documentData.split(';')[0].replace(/^data:/, '')
              let blob = b64toBlob(dataB64, contentType)
              let url = window.URL.createObjectURL(blob)
              let fileLink = document.createElement('a')
              fileLink.href = url
              fileLink.setAttribute('download', response.data.documentName)
              fileLink.click()
            }
            setTimeout(function () { that.$f7.hidePreloader() }, 1000)
          })
          .catch(error => {
            that.$f7.hidePreloader()
            errorMessageAlert(error, that)
            // errorMessageAlert(error, that)
          })
      } else {
        let attachmentData = this.attachments[id].AttachmentData
        let attachmentName = this.attachments[id].AttachmentName
        let dataB64 = attachmentData.split(',')[1]
        let contentType = attachmentData.split(';')[0].replace(/^data:/, '')
        let blob = b64toBlob(dataB64, contentType)
        let url = window.URL.createObjectURL(blob)
        let fileLink = document.createElement('a')
        fileLink.href = url
        fileLink.setAttribute('download', attachmentName)
        fileLink.click()
        // TO DO
      }
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// PRCreateTemplate.vue?1191087c